/**
 * 团队管理实体
 */

import { useEffect, useState } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    Select,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    rff,
} from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const MODULENAME = '团队';

const { Option } = Select;
const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [usersLists, setUsersLists] = useState([]);
    const [rolesLists, setRolesLists] = useState([]);
    const [loading, setLoading] = useState(false);
    const [groupname, setGroupname] = useState('');
    const [displayname, setDisplayname] = useState('');
    const [roleULID, setRoleULID] = useState('');
    const [adminUserULID, setAdminUserULID] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setIsModalOpen(false);
        setLoading(false);
        setGroupname('');
        setDisplayname('');
        setRoleULID('');
        setAdminUserULID('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setGroupname(props.record.groupname);
            setDisplayname(props.record.displayname);
            setAdminUserULID(props.record.admin_user_ulid);
            setRoleULID(props.record.role_ulid);
            setDescription(props.record.description);
        }
    }, [props.record]);

    useEffect(() => {
        if (props.isModalOpen && usersLists.length < 1) {
            /**
             * 获取用户下拉列表
             */
            $.ajax({
                url: `${CNF.api}users?rss=list`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON',
            }).done(function (data) {
                if (data.res === 0 && data.dat.length > 0) {
                    setUsersLists(data.dat)
                }
            });
        }
    }, [props.isModalOpen, usersLists]);

    useEffect(() => {
        if (props.isModalOpen && rolesLists.length < 1) {
            /**
             * 获取角色下拉列表
             */
            $.ajax({
                url: `${CNF.api}roles?rss=list`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON',
            }).done(function (data) {
                if (data.res === 0 && data.dat.length > 0) {
                    setRolesLists(data.dat)
                }
            });
        }
    }, [props.isModalOpen, rolesLists]);

    const ok = () => {
        var rex = CNF.regex.groupname.exec(groupname)
        if (rex == null || rex[0] !== groupname) {
            messageApi.error('组名格式错误！');
            return;
        }
        if (adminUserULID === '') {
            messageApi.error('管理员不能为空！');
            return;
        }
        if (roleULID === '') {
            messageApi.error('角色不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'groups' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'groupname': groupname,
                'role_ulid': roleULID,
                'admin_user_ulid': adminUserULID,
                'displayname': displayname,
                'description': description,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={400}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.isModalOpen}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row style={{}}>
                    <Col span={24}>{rff}团队名</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setGroupname(e.target.value)}
                            value={groupname}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}显示名</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setDisplayname(e.target.value)}
                            value={displayname}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}管理员</Col>
                    <Col span={24}>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            value={adminUserULID}
                            onChange={(value) => setAdminUserULID(value)}
                            disabled={loading}
                            filterOption={(input, option) =>
                                option.props.children.indexOf(input) >= 0
                            }
                        >
                            <Option value=''>请选择管理员</Option>
                            {
                                usersLists.length && usersLists.map((item, index) => {
                                    return <Option key={index} value={item['key']}>{item['username']}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}角色</Col>
                    <Col span={24}>
                        <Select value={roleULID}
                            style={{ width: '100%' }}
                            onChange={(value) => setRoleULID(value)}
                            disabled={loading}
                        >
                            <Option value=''>请选择组角色</Option>
                            {
                                rolesLists.length && rolesLists.map((item) => {
                                    return <Option key={item['key']} value={item['key']}>{item['rolename']}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>描述</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='团队描述可写在这里...'
                            autosize={{ minRows: 3, maxRows: 3 }}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                            value={description}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity;